import type { IconProps } from "../../types/global.types";

export default function EditIcon({ className, size }: IconProps) {
  return (
    <div className={className}>
      <svg
        width={size || "1em"}
        height={size || "1em"}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3187 3.45382L13.0612 2.71132C13.6763 2.09623 14.6736 2.09623 15.2887 2.71132C15.9037 3.32643 15.9037 4.3237 15.2887 4.9388L14.5462 5.68129M12.3187 3.45382L7.32419 8.4483C6.94355 8.829 6.67353 9.30585 6.54298 9.82807L6 12L8.17192 11.457C8.69415 11.3265 9.171 11.0564 9.5517 10.6758L14.5462 5.68129M12.3187 3.45382L14.5462 5.68129"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M14.2499 10.125C14.2499 12.5906 14.2499 13.8234 13.569 14.6532C13.4443 14.8051 13.3051 14.9443 13.1531 15.069C12.3234 15.75 11.0905 15.75 8.62492 15.75H8.25C5.42157 15.75 4.00737 15.75 3.12869 14.8713C2.25002 13.9927 2.25 12.5784 2.25 9.75V9.375C2.25 6.90939 2.25 5.67659 2.93095 4.84683C3.05563 4.69493 3.19493 4.55563 3.34683 4.43095C4.17659 3.75 5.40939 3.75 7.875 3.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
